import { createContext, useContext, Dispatch, SetStateAction } from 'react'
import { RefCallbackOptions } from './Provider'
import type { FiltersCollection } from 'utils/filtersCollections/filtersCollectionsRegistry'

type ContextType = {
  reactTableProps?: any
  setReactTableProps: Dispatch<SetStateAction<any>>
  setTableContentRef: Dispatch<SetStateAction<any>>
  tableContentRef: HTMLElement | null
  setCollapsibleHeader: (
    ref: HTMLElement | null,
    ops?: RefCallbackOptions
  ) => void
  filtersCollection: FiltersCollection | null
  // setFiltersCollection вызывается только из useTableFilters; остальные потребители читают filtersCollection
  setFiltersCollection: Dispatch<SetStateAction<FiltersCollection | null>>
}

const TableContext = createContext<ContextType>({
  reactTableProps: {},
  tableContentRef: null,
  setReactTableProps: () => {},
  setTableContentRef: () => {},
  setCollapsibleHeader: () => {},
  filtersCollection: null,
  setFiltersCollection: () => {},
})

export const useTableContext = () => useContext(TableContext)

export default TableContext
